import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Result, Button, Typography, Card } from 'antd';

const { Text } = Typography;

const CODE_MESSAGES = {
    INVALID_CARD_NUMBER: '카드번호가 올바르지 않습니다. 카드번호를 다시 확인해 주세요.',
    INVALID_CARD_EXPIRATION: '카드 유효기간이 올바르지 않습니다. 다시 확인해 주세요.',
    INVALID_CARD_INSTALLMENT_PLAN: '할부 개월 수가 올바르지 않습니다.',
    NOT_SUPPORTED_INSTALLMENT_PLAN: '해당 카드는 할부 결제를 지원하지 않습니다.',
    INVALID_CARD_LOST_OR_STOLEN: '분실 또는 도난 카드로 등록된 카드입니다. 카드사에 문의해 주세요.',
    RESTRICTED_CARD_USE: '사용이 제한된 카드입니다. 카드사에 문의해 주세요.',
    EXCEED_MAX_ONE_DAY_AMOUNT: '카드 일일 한도를 초과했습니다.',
    EXCEED_MAX_ONE_TIME_AMOUNT: '카드 1회 결제 한도를 초과했습니다.',
    EXCEED_MAX_AMOUNT: '카드 한도를 초과했습니다.',
    CARD_PROCESSING_ERROR: '카드사 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    NOT_SUPPORTED_CARD_TYPE: '지원하지 않는 카드 종류입니다.',
    REJECT_CARD_COMPANY: '카드사에서 결제를 거절했습니다. 카드사에 문의해 주세요.',
    USER_CANCEL: '결제를 취소했습니다.',
    TIMEOUT: '결제 시간이 초과되었습니다. 다시 시도해 주세요.',
    ALREADY_PROCESSED_PAYMENT: '이미 처리된 결제입니다.',
    AUTHORIZATION_FAILED: '카드 인증에 실패했습니다. 카드 정보를 다시 확인해 주세요.',
    PAY_PROCESS_ABORTED: '결제가 중단되었습니다. 다시 시도해 주세요.',
    PAY_PROCESS_DUPLICATED: '동일한 결제가 이미 진행 중입니다. 잠시 후 다시 시도해 주세요.',
    FORBIDDEN_CONSECUTIVE_REQUEST: '짧은 시간 내 동일한 결제 요청이 반복되었습니다. 잠시 후 다시 시도해 주세요.',
};

export const PaymentFail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const rawMessage = searchParams.get('message') || '결제 중 알 수 없는 오류가 발생했습니다.';
    const code = searchParams.get('code');
    const message = (code && CODE_MESSAGES[code]) || rawMessage;

    return (
        <div style={{ padding: '80px 20px', maxWidth: '600px', margin: '0 auto' }}>
            <Card
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
                    textAlign: 'center',
                }}
            >
                <Result
                    status="error"
                    title="결제에 실패했습니다"
                    subTitle={
                        <div>
                            <Text
                                style={{
                                    fontSize: '15px',
                                    color: '#595959',
                                    display: 'block',
                                    marginBottom: '8px',
                                }}
                            >
                                {message}
                            </Text>
                            {code && <Text type="secondary">에러 코드: {code}</Text>}
                        </div>
                    }
                    extra={[
                        <Button
                            type="primary"
                            size="large"
                            key="retry"
                            onClick={() => navigate('/grade-guide')}
                            style={{ borderRadius: '8px' }}
                        >
                            다시 시도하기
                        </Button>,
                    ]}
                />
            </Card>
        </div>
    );
};

export default PaymentFail;
